import React from "react";
import "./comment.less";
import _ from "underscore";
import { useTranslation } from "react-i18next";

const Comment = ({setValue}) => {
  const { t } = useTranslation();
  
  return (
    <div className="col-auto commentContainer">
      <label>{t("lbl.ADD_COMMENT", "Add comment")}</label>
      <textarea
        name="action_comment"                
        placeholder={t("lbl.ADD_YOUR_COMMENT", "Add your comment here.")}
        rows={8}
        maxLength={500}
        onChange={e => _.debounce(setValue(e.target.value),500)}
      />
    </div>
  );
};

export default Comment;
